<template>
    <div class="grid grid-cols-3">
        <button
            :disabled="value <= min"
            class="border-stroke-1 flex h-10 w-10 cursor-pointer items-center justify-center border-1 bg-zinc-900 disabled:cursor-not-allowed disabled:opacity-75"
            @click="decrement()"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 11L18 11L18 13L6 13L6 11Z"
                    fill="white"
                />
            </svg>
        </button>

        <div class="flex h-10 w-10 items-center justify-center text-center text-white">
            <p class="font-bold">
                {{ value }}
            </p>
        </div>

        <button
            :disabled="value >= max"
            class="border-stroke-1 flex h-10 w-10 cursor-pointer items-center justify-center border-1 bg-zinc-900 disabled:cursor-not-allowed disabled:opacity-75"
            @click="increment()"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 11L11 6L13 6L13 11L18 11L18 13L13 13L13 18L11 18L11 13L6 13L6 11L11 11Z"
                    fill="white"
                />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',
    props: {
        modelValue: {
            default: 0,
        },
        min: {
            type: Number,
            required: false,
            default: 0,
        },
        max: {
            type: Number,
            required: false,
            default: 10,
        },
        onlyOdd: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            value: this.modelValue || 0,
        }
    },
    watch: {
        modelValue(newValue) {
            this.value = newValue
        },
    },
    computed: {
        columns() {
            return this.options.length
        },
    },
    methods: {
        ensureOdd(value) {
            if (!this.onlyOdd) return value
            if (value % 2 === 0) {
                const nextOdd = value + 1
                const prevOdd = value - 1
                if (nextOdd <= this.max) {
                    return nextOdd
                } else if (prevOdd >= this.min) {
                    return prevOdd
                } else {
                    return this.min % 2 === 1 ? this.min : this.min + 1
                }
            }
            return value
        },
        updateValue(newValue) {
            const adjustedValue = this.ensureOdd(newValue)
            this.value = adjustedValue
            this.$emit('update:modelValue', this.value)
        },
        increment() {
            let newValue = this.value + 1

            if (this.onlyOdd) {
                if (newValue % 2 === 0) {
                    newValue = newValue + 1
                }
            }

            if (newValue <= this.max) {
                this.updateValue(newValue)
            } else {
                console.log('blocked because of max limit')
            }
        },
        decrement() {
            let newValue = this.value - 1

            if (this.onlyOdd) {
                if (newValue % 2 === 0) {
                    newValue = newValue - 1
                }
            }

            if (newValue >= this.min) {
                this.updateValue(newValue)
            } else {
                console.log('blocked because of min limit')
            }
        },
    },
}
</script>

<style scoped>
.custom-select select {
    padding: 0.5rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 1rem;
}
</style>
